import { pathJoin } from '../../../utils'

export const createEditBulkRoutesMap = (prefix: string) => ({
  'ticket-details': pathJoin(prefix)('ticket-details').chain,
  'selected-tickets': pathJoin(prefix)('selected-tickets').chain,
})
